import PropTypes from 'prop-types';
import { Component } from 'react';

export default class SystemsView extends Component {

  /* Render */

  render() {
    return this.props.children;
  }
}

SystemsView.propTypes = {
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./js/views/systems/index.jsx